/* eslint-disable import/prefer-default-export */
import { getCurrentInstance } from 'vue'

export const useGlobalProperties = () => getCurrentInstance().appContext.config.globalProperties
